// Picks this result can't offer (from a saved plan, an edited attempt or earlier confirmations): shown, never silently dropped.
import React from "react";

const ORIGIN = {
  plan: "your saved plan for this result",
  draft: "your current selection",
  "earlier-plan": "the plan you saved on the attempt you edited",
  confirmed: "subjects you confirmed earlier",
};

export function UnmatchedPicks({ keys, confirmed, source, onRemove }) {
  const tid = (k) => String(k).toLowerCase().replace(/[^a-z0-9]+/g, "-");
  const label = (k) => (confirmed || []).find((c) => (c?.slug || c) === k)?.label || k;
  return (
    <div id="pick-review" className="mt-6 scroll-mt-56 rounded-xl border border-amber-200 bg-amber-50/70 p-4 text-sm text-amber-900 print:hidden" data-testid="pick-review-unmatched">
      <p data-testid="pick-review-unmatched-copy">
        {keys.length === 1 ? "This subject" : "These subjects"} from {ORIGIN[source] || "your earlier choices"} {keys.length === 1 ? "isn't" : "aren't"} offered
        in this result. Nothing has been removed. Remove {keys.length === 1 ? "it" : "them"} here before you save or confirm a new set.
      </p>
      <ul className="mt-2 flex flex-wrap gap-2">
        {keys.map((k) => (
          <li key={k} className="inline-flex items-center gap-2 rounded-full border border-amber-300 bg-white px-3 py-1" data-testid={`pick-review-unmatched-${tid(k)}`}>
            {label(k)}
            <button type="button" onClick={() => onRemove(k)} className="text-xs font-medium text-amber-900 underline" data-testid={`pick-review-remove-${tid(k)}`}>Remove</button>
          </li>
        ))}
      </ul>
    </div>
  );
}

// Plan full: pick which current subject to swap out for the one just chosen (nothing else changes).
export function SwapPicker({ incoming, current, onSwap, onCancel }) {
  const tid = (k) => String(k).toLowerCase().replace(/[^a-z0-9]+/g, "-");
  return (
    <div role="dialog" aria-label={`Swap in ${incoming}`} className="mb-2 rounded-xl border border-[#7C3AED]/40 bg-[#F5F0FF] px-4 py-3 text-sm text-slate-800 print:hidden" data-testid="coursefit-swap-picker">
      <p>You already have 3 subjects. Swap <b className="font-semibold">{incoming}</b> in for:</p>
      <div className="mt-2 flex flex-wrap gap-2">
        {current.map((c) => (
          <button key={c.key} type="button" onClick={() => onSwap(c.key)} data-testid={`coursefit-swap-out-${tid(c.key)}`}
            className="inline-flex min-h-[36px] items-center rounded-full border border-[#7C3AED] bg-white px-3 text-sm text-[#7C3AED] transition-colors hover:bg-[#7C3AED] hover:text-white">
            {c.label}
          </button>
        ))}
        <button type="button" onClick={onCancel} data-testid="coursefit-swap-cancel" className="inline-flex min-h-[36px] items-center px-2 text-sm text-slate-600 underline-offset-2 hover:underline">Cancel</button>
      </div>
    </div>
  );
}
